<script setup lang="ts">
withDefaults(
  defineProps<{
    height?: string | number | undefined;
    width?: string | number | undefined;
  }>(),
  {
    height: 74,
    width: 74,
  }
);
</script>

<template>
  <v-img src="/logo.png" :width="width" :height="height" />
</template>
